<template>
  <div id="login">
    <section class="bannerprincipal pb-2">
      <div
        class="col-12 text-center py-3"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <div class="row"></div>
      </div>
    </section>

    <div class="container-fluid bgblanco pb-3">
      <div class="row">
        <div class="col-12 col-lg-6" v-if="ticket != null">
          <form @submit="signup($event)" class="r15">
            <div class="col-12 text-left pt-1 pt-md-0 my-4 mb-5">
              <a
                href="/reportes/informe"
                class="btnaction btn-danger fXG2 pb-2 bold"
              >
                Cancelar</a
              >
            </div>

            <div class="col-12 text-left pt-1 pt-md-0 pb-4 mt-n4">
              <p class="fXG2 pb-2 blanco bold">Edición de Registro</p>
            </div>
            <div class="col-12 text-left pt-1 pt-md-0 pb-4 mt-n4">
              <p class="fG pb-2 blanco bold">ID Ticket: {{ ticket.id }}</p>
              <p class="fG pb-2 blanco bold">
                Email de usuario: {{ ticket.user_email }}
              </p>
            </div>
            <div class="col-12">
              <div class="row pb-4">
                <div class="col-lg-12 pb-0">
                  <div class="blanco fG">Cadena</div>
                  <input
                    v-model.trim="ticket.cadena"
                    type="text"
                    placeholder="Cadena"
                    required
                  />
                </div>
              </div>

              <div class="row pb-4">
                <div class="col-lg-12 pb-0">
                  <div class="blanco fG">Sucursal</div>
                  <input
                    v-model.trim="ticket.sucursal"
                    type="text"
                    placeholder="Sucursal"
                    required
                  />
                </div>
              </div>

              <div class="row pb-4">
                <div class="col-lg-12 pb-0">
                  <div class="blanco fG">Vendedor</div>
                  <input
                    v-model.trim="ticket.vendedor"
                    type="text"
                    placeholder="Vendedor"
                    required
                  />
                </div>
              </div>

              <div class="row pb-4">
                <div class="col-lg-12 pb-0">
                  <div class="blanco fG">Producto</div>
                  <input
                    v-model.trim="ticket.producto"
                    type="text"
                    placeholder="Producto"
                    required
                  />
                </div>
              </div>

              <div class="row pb-4">
                <div class="col-lg-12 pb-0">
                  <div class="blanco fG">Peso</div>
                  <input
                    v-model.trim="ticket.peso"
                    type="text"
                    placeholder="Peso"
                    required
                  />
                </div>
              </div>

              <div class="row pb-4">
                <div class="col-lg-12 pb-0">
                  <div class="blanco fG">Cantidad</div>
                  <input
                    v-model.trim="ticket.cantidad"
                    type="number"
                    placeholder="Cantidad"
                  />
                </div>
              </div>

              <div class="row pb-4">
  <div class="col-lg-12 pb-0">
    <div class="blanco fG">Fecha del ticket</div>
    <div class="row">

      <div class="col-md-3 pb-2">
        <label class="blanco fG" for="campoFecha">Fecha (YYYY-MM-DD)</label>
        <input
          id="campoFecha"
          v-model="fechaCampos.fecha"
          type="text"
          placeholder=""
          
        />
      </div>

      <div class="col-md-3 pb-2">
        <label class="blanco fG" for="campoHora">Horas (HH)</label>
        <input
          id="campoHora"
          v-model="fechaCampos.hora"
          type="text"
          placeholder=""
          maxlength="2"
           pattern="^\d{2}$"
  inputmode="numeric"
  title="Dígito de 2 números"
        />
      </div>

      <div class="col-md-3 pb-2">
        <label class="blanco fG" for="campoMinuto">Minutos (MM)</label>
        <input
          id="campoMinuto"
          v-model="fechaCampos.minuto"
          type="text"
          placeholder=""
          maxlength="2"
           pattern="^\d{2}$"
  inputmode="numeric"
  title="Dígito de 2 números"
        />
      </div>

      <div class="col-md-3 pb-2">
        <label class="blanco fG" for="campoSegundo">Segundos (SS)</label>
        <input
          id="campoSegundo"
          v-model="fechaCampos.segundo"
          type="text"
          placeholder=""
          maxlength="2"
           pattern="^\d{2}$"
  inputmode="numeric"
  title="Dígito de 2 números"
        />
      </div>

    </div>
  </div>
</div>


              <div class="row pb-5">
                <div class="col-12 text-center">
                  <button
                    type="submit"
                    class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                  >
                    Actualizar
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer"
                      >Regresar al Login</a
                    >
                  </div> -->
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
    </div>

    <!-- <Glyphicons></Glyphicons> -->

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import * as moment from "moment";

import * as fb from "../firebase";

import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    //Footer,
    //SiteNav,
    // Glyphicons,
  },
  data() {
    return {
      reenvioForm: {
        codigo: "",
      },
      idticket: "",
      cadena: "",
      sucursal: "",
      vendedor: "",
      cantidad: "",

      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        id: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      },
      fechaCampos:{
        fecha: '0000-00-00',
        hora: '00',
        minuto: '00',
        segundo: '00'
      },
      columnsRegistros: [
        "asistira_al_evento",
        "tipo",
        "codigo_qr",
        "nombre",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "telefono",
        "movil",
        "terminos",
        "asistio",
        "fecha_asistio",
        "email_operador",
        "timestamp",
      ],
      columnsInvitados: [
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "telefono",
        "movil",
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          tipo: "Tipo de registro",
          asistira_al_evento: "Asistirá al evento",
          email_operador: "Usuario que registró QR",
          cubrebocas: "Cubrebocas entregado",
          guantes: "Guantes entregado",
          kit_bienvenida: "Kit Bienvenida entregado",
          top: "Playera entregada",
          pulsera: "Pulsera entregada",
          asistio: "Asistió al evento",
          talla_tops: "Talla Playera",
          timestamp: "Fecha de registro en sistema",
        },
        editableColumns: [],
        sortable: [],
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      ticket: null,
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registros: [],
      invitados: [],
      user: null,
      contador_clinica: 0,
      contador_torneo: 0,
      contador_comida: 0,

      tope_clientes_se: 900,
      tope_equipo_prosa: 70,
      tope_staff_rp: 7,
      tope_patrocinios: 135,
      tope_medios: 20,
      tope_talks_2_code: 3,
      tope_ponentes: 32,

      clientes_se: 0,
      equipo_prosa: 0,
      staff_rp: 0,
      patrocinios: 0,
      medios: 0,
      talks_2_code: 0,
      ponentes: 0,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = JSON.parse(localStorage.getItem("user_foroprosa_2023"));

    this.getTicketById(this.$route.params.id);
  },
  methods: {
    quitarAcentos(elemento) {
      //console.log('quitando acentos')
      elemento = elemento.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //console.log({elemento})
      return elemento;
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    async changeStatusAsistenciaEvento(nombre, email, codigo_qr, status) {
      console.log({ changeStatusCodigo: codigo_qr });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        nombre: nombre,
        email: email,
        codigo_qr: codigo_qr,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusAsistenciaEvento.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async reenviarInvitacionQR(id) {
      console.log({ reenviarinvitacionqr: id });

      this.$store.dispatch("showLoader", true);

      var qData = {
        id: id,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res reenvio");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire(
                "Oops",
                "Hubo un problema al momento de reenviar el código QR, por favor intenta de nuevo.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTipoRegistro(id, email, status) {
      console.log({ changeStatusTipoRegistro: id });

      //revisar el tope antes de continuar
      if (status != "") {
        let temp_count = 0;
        let temp_tope = 0;
        switch (status) {
          case "Clientes & SE":
            temp_count = this.clientes_se;
            temp_tope = this.tope_clientes_se;
            break;
          case "Equipo Prosa":
            temp_count = this.equipo_prosa;
            temp_tope = this.tope_equipo_prosa;
            break;
          case "Staff Comm & RP":
            temp_count = this.staff_rp;
            temp_tope = this.tope_staff_rp;
            break;
          case "Patrocinios":
            temp_count = this.patrocinios;
            temp_tope = this.tope_patrocinios;
            break;
          case "Medios":
            temp_count = this.medios;
            temp_tope = this.tope_medios;
            break;
          case "Ponente":
            temp_count = this.ponentes;
            temp_tope = this.tope_ponentes;
            break;
          case "Talks 2 Code":
            temp_count = this.talks_2_code;
            temp_tope = this.tope_talks_2_code;
            break;
        }

        if (temp_count >= temp_tope) {
          swal.fire(
            "Operación no realizada",
            "Se ha llegado al tope máximo para este tipo de registro.",
            "warning"
          );

          return;
        }
      }

      this.$store.dispatch("showLoader", true);

      var qData = {
        id: id,
        email: email,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTipoRegistro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res reenvio");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");

              for (var i = 0; i < this.registros.length; i++) {
                if (this.registros[i].id === id) {
                  this.registros[i].tipo = status;
                }
              }

              this.cuentaRegistros();
            } else {
              swal.fire(
                "Oops",
                "Hubo un problema al momento de intentar actualizar el tipo de registro, intenta más tarde.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusComida(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusComida.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTorneo(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTorneo.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTalla(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTalla.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusGuantes(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusGuantes.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusHorarioClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusHorarioClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusCubrebocas(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusCubrebocas.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    async getTicketById(ticketId) {
      console.log("Getting ticket with ID:", ticketId);

      try {
        const doc = await ticketsCollection.doc(ticketId).get();

        if (doc.exists) {
          const ticket = doc.data();
          ticket.id = doc.id; // opcional, si quieres incluir el ID
          if (ticket.cantidad == undefined || ticket.cantidad == null) {
            ticket.cantidad = 1;
          }
          
           if (ticket?.ticket_ocr?.date) {
            const [fecha, tiempo] = ticket.ticket_ocr.date.split(' ');
            const [hora, minuto, segundo] = tiempo.split(':');
            this.fechaCampos = {
              fecha,
              hora,
              minuto,
              segundo,
            };
          }

          this.ticket = ticket; // si quieres que sea un array

          console.log({ ticket: this.ticket });
        } else {
          console.log("No ticket found with that ID");
          this.tickets = [];
        }
      } catch (error) {
        console.error("Error getting ticket:", error);
      }
    },
    getRegistro() {
      console.log("get registros");

      const https = require("https");
      var qData = {
        id: this.$route.params.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistroAdmin.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.signupForm.id = this.$route.params.id;
              this.signupForm.nombre = res.datos[0].nombre;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;
              this.signupForm.ext = res.datos[0].ext;

              this.cuentaRegistros();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    cuentaRegistros() {
      this.clientes_se = 0;
      this.equipo_prosa = 0;
      this.staff_rp = 0;
      this.patrocinios = 0;
      this.medios = 0;
      this.talks_2_code = 0;
      this.ponentes = 0;

      for (var i = 0; i < this.registros.length; i++) {
        if (this.registros[i].tipo == "Clientes & SE") {
          this.clientes_se++;
        }
        if (this.registros[i].tipo == "Equipo Prosa") {
          this.equipo_prosa++;
        }
        if (this.registros[i].tipo == "Staff Comm & RP") {
          this.staff_rp++;
        }
        if (this.registros[i].tipo == "Patrocinios") {
          this.patrocinios++;
        }
        if (this.registros[i].tipo == "Medios") {
          this.medios++;
        }
        if (this.registros[i].tipo == "Ponente") {
          this.ponentes++;
        }
        if (this.registros[i].tipo == "Talks 2 Code") {
          this.talks_2_code++;
        }
      }
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.reenvioForm.codigo = "";

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.fechaCampos });

      const { fecha, hora, minuto, segundo } = this.fechaCampos;

      if (fecha && hora && minuto && segundo) {
        const fechaFormateada = `${fecha} ${hora}:${minuto}:${segundo}`;

        // Asegurarse de que ticket_ocr exista
        if (!this.ticket.ticket_ocr) {
          this.ticket.ticket_ocr = {};
        }

        this.ticket.ticket_ocr.date = fechaFormateada;
      }


      //this.enviaRegistro();
      let ticket_obj = this.$store.dispatch("actualizaTicketAdmin", {
        ticket_obj: this.ticket,
      });
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "edicionRegistroXAdmin.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              swal
                .fire({
                  title: "Bien",
                  html: res.msg,
                  icon: "success",
                  confirmButtonText: "Ok",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    this.$router.push("/administrador/dashboard/");
                  }
                });
              //this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signupInvitado(e) {
      e.preventDefault();
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registroInvitadoXAdmin.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.talla_cubrebocas = "";
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.horario_clinica = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      };
    },
  },
};
</script>

